import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const InsuranceStrategyGuide = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden" data-testid="insurance-strategy-guide">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-muted/30"
      >
        <span className="text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="BookOpen" size={16} className="text-primary" />
          Assurance comme actif et collatéral (PFI)
        </span>
        <Icon name={open ? 'ChevronUp' : 'ChevronDown'} size={18} className="text-muted-foreground" />
      </button>
      {open && (
        <div className="px-4 pb-4 text-xs text-muted-foreground space-y-3 border-t border-border pt-3">
          <p>
            <strong className="text-foreground">Valeur de rachat (VR)</strong> : actif au bilan, croissance généralement à l&apos;abri de l&apos;impôt. La <strong className="text-foreground">valeur nette</strong> utilise la VR, pas le capital décès.
          </p>
          <p>
            <strong className="text-foreground">Prêt collatéral</strong> (institution externe, jusqu&apos;à ~90 % VR) : liquidités non imposables à l&apos;emprunt, n&apos;affecte pas le CBR. Distinct de l&apos;<strong className="text-foreground">avance sur police</strong> (disposition imposable).
          </p>
          <p>
            <strong className="text-foreground">PFI</strong> : avances annuelles de prêt, intérêts potentiellement déductibles si revenus admissibles, remboursement au décès. Société : le CDC est crédité de 100 % du capital décès (le prêt collatéral n&apos;en réduit pas le montant).
          </p>
          <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-2">
            ImmoIQ fournit des estimations. Validez CBR, CDC, déductibilité et structures juridiques avec votre fiscaliste.
          </p>
        </div>
      )}
    </div>
  );
};

export default InsuranceStrategyGuide;
